import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import styled from '@emotion/styled';
import BackgroundButton, { BackgroundButtonProps } from './BackgroundButton';

interface Props extends BackgroundButtonProps {
    tooltipTitle: React.ReactNode;
    arrow?: boolean;
    placement?: 'top' | 'bottom' | 'left' | 'right';
    customBackgroundColor?: string;
    fitContent?: boolean;
    tooltipStyles?: React.CSSProperties;
}

const StyledTooltip = styled(CustomTooltip)`
    position: absolute;
    top: 0;
    right: 0;
    display: inline-flex;
`;

const slotProps = {
    tooltip: {
        sx: {
            position: 'relative',
            left: '-24px',
            pointerEvents: 'auto',
        },
    },
};

const TooltipBackgroundButton = ({
    tooltipTitle,
    arrow = false,
    customBackgroundColor,
    placement = 'top',
    fitContent = true,
    tooltipStyles,
    ...buttonProps
}: Props) => (
    <StyledTooltip
        title={tooltipTitle}
        placement={placement}
        arrow={arrow}
        tooltipStyles={tooltipStyles}
        slotProps={slotProps}
        customBackgroundColor={customBackgroundColor}
        fitContent={fitContent}>
        <BackgroundButton {...buttonProps} />
    </StyledTooltip>
);

export default TooltipBackgroundButton;
